import { lazy } from 'react';
import { Permission } from '@condo/domain';
import type { RamRouteObject } from '@/shared/lib/permissions';

const AssetAnalyserDeskPage = lazy(() => import('@/pages/asset-analyser/AssetAnalyserDeskPage'));
const AssetAnalyserWorkspacePage = lazy(() => import('@/pages/asset-analyser/AssetAnalyserWorkspacePage'));

export const assetAnalyserRoutes: RamRouteObject[] = [
    {
        path: 'asset-analyser',
        element: <AssetAnalyserDeskPage />,
        permissions: [Permission.MFHAssetAnalyzerView],
        name: 'asset-analyser.desk',
    },
    {
        path: 'asset-analyser/:analysisId/*',
        element: <AssetAnalyserWorkspacePage />,
        permissions: [Permission.MFHAssetAnalyzerView],
        name: 'asset-analyser.workspace',
    },
];
